<div [ngClass]="{'type-b': templateSuffix !== ''}">
  <form [formGroup]="form">
    <div class="row campos">
      <div class="col-md-12" [ngClass]=" isBetweenActivated ? 'col-lg-5' : 'col-lg-6' " >
        <label for="calle"> Calle <span class="input-required"> * </span> </label>
        <input [ngClass]="hasErrors('calle')" id="calle" type="text" class="form-control" formControlName="calle" />
        <span *ngIf="isInvalid('calle')">Calle requerida</span>
      </div>
      <div class="col-md-12 col-lg" *ngIf="isBetweenActivated">
        <label for="between"> Entre Calles </label>
        <input [ngClass]="hasErrors('betweenStreets')" id="between" type="text mt-4 " class="form-control"
          formControlName="betweenStreets" />
      </div>
      <div class="col-md-12 col-lg">
        <label for="ext"> Núm. Exterior <span class="input-required"> * </span> </label>
        <input [ngClass]="hasErrors('numExt')" id="ext" type="text mt-4 " class="form-control" formControlName="numExt" />
        <span *ngIf="isInvalid('numExt')">Exterior requerido</span>
      </div>
      <div class="col-md-12 col-lg">
        <label for="int"> Núm. Interior </label>
        <input id="int" type="text" class="form-control" formControlName="numInt" />
      </div>
    </div>

    <div class="row campos">
      <div class="col-xl-2 col-12 mt-4">
        <label for="cp"> CP <span class="input-required"> * </span> </label>
        <input [ngClass]="hasErrors('cp')" id="cp" type="text" class="form-control" formControlName="cp" />
        <span *ngIf="isInvalid('cp')">4 o 5 dígitos</span>
      </div>

      <div class="col-xl-5 col-12 mt-4">
        <label for="colonia"> Colonia <span class="input-required"> * </span> </label>
        <select [ngClass]="hasErrors('colonia')" class="form-control" id="colonia" formControlName="colonia">
          <option [ngValue]="colony.idAsentaCpCons" *ngFor="let colony of colonies; let i = index">
            {{ colony.dasenta }}
          </option>
        </select>
        <span *ngIf="isInvalid('colonia')">Colonia requerida</span>
      </div>

      <div class="col-xl-5 col-12 mt-4">
        <label for="municipio"> Alcaldía / Municipio <span class="input-required"> * </span> </label>
        <select class="form-control select-disabled" id="cityId" formControlName="cityId">
          <option [ngValue]="municipality.cityId" *ngFor="let municipality of municipalities; let i = index">
            {{ municipality.cityDesc }}
          </option>
        </select>
      </div>
    </div>

    <div class="row campos">
      <div class="col-12 mt-4" [ngClass]="  isBetweenActivated ? 'col-lg-4' : 'col-lg-6' " >
        <label for="ciudad"> Ciudad <span class="input-required"> * </span> </label>
        <input id="municipality" type="text" class="form-control" formControlName="municipality" />
      </div>
      <div class="col-lg col-12 mt-4" *ngIf="states.length !== 0">
        <label for="estado"> Estado <span class="input-required"> * </span> </label>
        <select  #stateSelect class="form-control select-disabled" id="estado" formControlName="stateId">
          <option [ngValue]="state.idDaVinci" *ngFor="let state of states; let i = index">
            {{ state.stateName }}
          </option>
        </select>
      </div>
      <div class="col-lg col-12 mt-4" *ngIf="isBetweenActivated">
        <label for="">País<span class="input-required">*</span></label>
        <select class="form-control" id="" formControlName="countryId">
          <option [value]="pais.countryId" *ngFor="let pais of paises; let i = index">
            {{ pais.countryDesc }}
          </option>
        </select>
      </div>
    </div>
  </form>


  <div class="error-info p-2 mt-2 d-flex flex-column justify-content-center align-items-cente" *ngIf="getInfoHasErrors">
    <strong>
      El código postal no fue encontrado intente nuevamente o con otro
    </strong>
  </div>

  <div class="mt-2 pl-5 d-flex flex-column justify-content-center align-items-center" *ngIf="loading">
    <h3 class="mb-0">
      <strong class="color-font">
        Obteniendo su dirección espere por favor...
      </strong>
    </h3>
    <app-loading-spinner diameter="75px"></app-loading-spinner>
  </div>
</div>